export default __webpack_public_path__ + "static/media/TitilliumWeb-Regular.d12d548a.woff2";